import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ClipboardPaste } from "lucide-react";
import { NeuInput } from "../../components/neu/Neu";

// Emailed 6-digit code. Auto-fills from the clipboard when the user returns from the mail app.
export const DeleteAccountCode = ({ code, setCode, email }) => {
  const { t } = useTranslation();
  const digits = code.replace(/\D/g, "").slice(0, 6);

  useEffect(() => {
    const grab = async () => {
      if (digits.length === 6 || document.hidden) return;
      const text = await navigator.clipboard?.readText().catch(() => "");
      const found = (text?.match(/\d{6}/) || [])[0];
      if (found) setCode(found);
    };
    grab();
    window.addEventListener("focus", grab);
    document.addEventListener("visibilitychange", grab);
    return () => {
      window.removeEventListener("focus", grab);
      document.removeEventListener("visibilitychange", grab);
    };
  }, [digits, setCode]);

  const paste = async () => {
    const text = await navigator.clipboard?.readText().catch(() => "");
    const found = (text?.match(/\d{6}/) || [])[0];
    if (found) setCode(found);
  };

  return (
    <div className="grid gap-2">
      <p className="text-xs font-bold text-destructive">{t("account.deleteCodeHint", { email })}</p>
      <NeuInput
        data-testid="delete-account-code"
        autoFocus
        type="text"
        name="otp"
        autoComplete="one-time-code"
        inputMode="numeric"
        pattern="[0-9]*"
        maxLength={6}
        value={digits}
        onChange={(e) => setCode(e.target.value)}
        onPaste={(e) => setCode((e.clipboardData.getData("text").match(/\d{6}/) || [""])[0])}
        placeholder="••••••"
        className="text-center font-mono text-2xl tracking-[0.6em]"
      />
      <button
        type="button"
        data-testid="delete-account-paste"
        onClick={paste}
        className="flex items-center gap-1 text-xs font-bold text-primary"
      >
        <ClipboardPaste className="h-4 w-4" />
        {t("archiveCompany.paste")}
      </button>
    </div>
  );
};
